import VueRouter from 'vue-router';


const router = new VueRouter({

    mode: 'history',
    routes: [
        {
            path: '/:id',
            name: 'home',
        },
    ]
});

export {router};
